import Countries from './Countries';

export default Countries;



// WEBPACK FOOTER //
// ./src/pages/Countries/index.ts